import { render, staticRenderFns } from "./Suscription.vue?vue&type=template&id=990d7b0c&scoped=true"
import script from "./Suscription.vue?vue&type=script&lang=js"
export * from "./Suscription.vue?vue&type=script&lang=js"
import style0 from "./Suscription.vue?vue&type=style&index=0&id=990d7b0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990d7b0c",
  null
  
)

export default component.exports